import React from 'react';
import PropTypes from 'prop-types';
// Core components
import Box from 'components/core/Box';
// Custom
import { cpmPriceGridDataShape, cpmBookingPriceGridDataShape } from 'constants/PropTypesShapes';
import PriceGridTable from './PriceGridTable';

const PriceGridInfo = ({ priceGrid, background }) => (
  <Box type={background} className="p-3">
    <PriceGridTable priceGrid={priceGrid} />
  </Box>
);

PriceGridInfo.propTypes = {
  priceGrid: PropTypes.oneOfType([cpmPriceGridDataShape, cpmBookingPriceGridDataShape]).isRequired,
  background: PropTypes.oneOf(['defaultBackground', 'checkoutBackground']),
};

PriceGridInfo.defaultProps = {
  background: 'defaultBackground',
};

module.exports = PriceGridInfo;



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/priceGrids/PriceGridInfo.js